export default __webpack_public_path__ + "static/media/file.f9c70725.svg";